// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSelectedProductPath } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getById } from "@insite/client-framework/Store/Data/DataState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import { shallowEqual, useSelector } from "react-redux";

/* The original version of this selector returns not only a new object but also a nested object with productState and attributeTypes.  Because of this its impossible to do a shallowEqual on the return value. 
so we're moving attributeTypes out of the value object so that we can do a shallowEqual on the return value. */
function getProductStateByPathShallowQuality(state: ApplicationState, path: string | undefined) {
    const productState = getById(state.data.products, path, id => state.data.products.idByPath[id]);
    if (path) {
        const attributeTypes = state.data.products.attributeTypesByPath[path];
        if (attributeTypes && productState.value) {
            return {
                isLoading: productState.isLoading,
                id: productState.id,
                value: productState.value,
                attributeTypes: attributeTypes ?? [],
            };
        }
    }

    return { ...productState };
}
export default () => {
    const productState = useSelector((state: ApplicationState) => {
        const location = getLocation(state);
        const productPath =
            getSelectedProductPath(state) ||
            (location.pathname.toLowerCase().startsWith("/content/") ? "" : location.pathname);

        return getProductStateByPathShallowQuality(state, productPath);
    }, shallowEqual);
    return {
        ...productState.value,
        attributeTypes: productState?.attributeTypes ?? productState.value?.attributeTypes ?? [],
    } as Readonly<ProductModel>;
};
